import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'proffeo-groups',
  template: '<router-outlet></router-outlet>',
  imports: [RouterModule]
})
export class GroupsComponent {}
